import React from 'react';

export default function Navbar() {
  return (
    <nav className='text-center'>
      <h3>Random Date Generator</h3>
    </nav>
  );
}
